export default {
    JUST_TEXT: 'JUST_TEXT',
    JUST_ATTACHMENT: 'JUST_ATTACHMENT',
    TEXT_AND_ATTACHMENT: 'TEXT_AND_ATTACHMENT',
    SMALL_TEXT: 'SMALL_TEXT',
};



// WEBPACK FOOTER //
// ./src/utils/activity-content-types.js